export const initCalltouch = ( form ) => {
	let calltouchPhone, calltouchData = [];

	Array.from( form.querySelectorAll( 'input:not([name="personal_data"])' ) ).forEach( ( it ) => {
		if ( it.name === 'phone' )
		{
			calltouchPhone = it.value.replace( /\D/g, '' );
		}
		else if ( it.name === 'name' || it.name === 'subject' )
		{
			calltouchData.push( {
				name: it.name,
				value: it.value
			} );
		}
	} );

	if ( !calltouchPhone || !window.ctw )
	{
		return;
	}

	window.ctw.createRequest( 'default', calltouchPhone, calltouchData, ( success, data ) => { console.log( success, data ) }, null, [] );
};